import {
    ChallengeAggregationType,
    ChallengeFitnessMetricType,
    ChallengeInitialResultMode,
    ChallengeNormalizationOperation,
    ChallengeNormalizationOutputFormat,
    ChallengeRuleType
} from '@core/api/ChallengeClient';
import { COMPOSITE_POINTS_RULE_TYPE } from '../../rule-types';

export const ruleTypeOptions = [
    { label: 'Activity points', value: ChallengeRuleType.ACTIVITY_POINTS },
    {
        label: 'Activity raw value',
        value: ChallengeRuleType.ACTIVITY_RAW_VALUE
    },
    { label: 'Activity count', value: ChallengeRuleType.ACTIVITY_COUNT },
    { label: 'Composite points', value: COMPOSITE_POINTS_RULE_TYPE }
];

export const fitnessMetricOptions = [
    { label: 'Pace', value: ChallengeFitnessMetricType.PACE },
    { label: 'Distance', value: ChallengeFitnessMetricType.DISTANCE },
    {
        label: 'Minutes',
        value: ChallengeFitnessMetricType.ACTIVITY_TIME_IN_MINUTES
    },
    { label: 'Steps', value: ChallengeFitnessMetricType.STEPS },
    { label: 'Calories', value: ChallengeFitnessMetricType.CALORIES },
    {
        label: 'Calculated metric',
        value: ChallengeFitnessMetricType.WORKOUT_CALCULATED_METRIC
    }
];

export const aggregationOptions = [
    { label: 'Sum', value: ChallengeAggregationType.SUM },
    { label: 'Max', value: ChallengeAggregationType.MAX },
    { label: 'Min', value: ChallengeAggregationType.MIN }
];

export const normalizationOperationOptions = [
    { label: 'None', value: undefined },
    { label: 'Multiply', value: ChallengeNormalizationOperation.MULTIPLY }
];

export const normalizationOutputFormatOptions = [
    { label: 'Duration', value: ChallengeNormalizationOutputFormat.DURATION },
    { label: 'Number', value: ChallengeNormalizationOutputFormat.NUMBER }
];

export const initialResultModeOptions = [
    {
        label: "Today's points so far",
        value: ChallengeInitialResultMode.CURRENT_DAY_ONLY
    },
    {
        label: 'Nothing — only what comes after joining',
        value: ChallengeInitialResultMode.INCREMENTAL
    }
];
